import {ADD_COMPANY_DATA, GET_COMPANY_DATA, PUBLIC_BRANCH_CHANGE, REDIRECT_PUBLIC_USER} from '../actionTypes';

const INITIAL_STATE = {
  companyId: null,
  branchId: null,
  userId: null,
  clientName: '',
};

const buildClientName = member => {
  if (!member) return '';
  if (member.name) return member.name;
  return [member.firstName, member.lastName].filter(Boolean).join(' ').trim();
};

const coalesce = (current, next) => (next !== undefined && next !== null && next !== '' ? next : current);

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_COMPANY_DATA:
    case ADD_COMPANY_DATA: {
      const payload = action.payload || {};
      const member = payload.member || {};
      const clientName = buildClientName(member);

      return {
        ...state,
        companyId: coalesce(state.companyId, payload.id || payload.companyId),
        branchId: coalesce(state.branchId, payload.branch?.id || payload.branchId),
        userId: coalesce(state.userId, member.id),
        clientName: coalesce(state.clientName, clientName),
      };
    }
    case REDIRECT_PUBLIC_USER: {
      const payload = action.payload || {};
      return {
        ...state,
        companyId: coalesce(state.companyId, payload.companyId),
      };
    }
    case PUBLIC_BRANCH_CHANGE: {
      const payload = action.payload || {};
      const branchId = payload.branchSelected?.id || payload.branchId;
      return {
        ...state,
        companyId: coalesce(state.companyId, payload.companyId),
        branchId: coalesce(state.branchId, branchId),
      };
    }
    default:
      return state;
  }
};

export default reducer;
